module.exports = __webpack_public_path__ + "static/media/COS_KENVUE.4ecea63e.webp";